/* eslint-disable operator-linebreak */
/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';

import {
  Comment,
  Paragraph,
  H1, H2, H3,
} from './styles';

/*
  ## Destaques (Títulos) ##
*/

export const Spotlight = ({ children }) => (
  <H1>{children}</H1>
);

Spotlight.propTypes = {
  children: PropTypes.any.isRequired,
};

/*
  ## Títulos principais e secundarios ##
*/

export const Title = ({ children, secondary, ...params }) => (
  secondary ? <H3 {...params}>{children}</H3> : <H2>{children}</H2>
);

Title.defaultProps = {
  secondary: false,
};

Title.propTypes = {
  secondary: PropTypes.bool,
  children: PropTypes.any.isRequired,
};

/*
  ## Textos gerais e observações ##
*/

export const Text = ({ children, comment, ...params }) => (
  comment ?
    <Comment {...params}>{children}</Comment> :
    <Paragraph comment {...params}>{children}</Paragraph>
);

Text.defaultProps = {
  comment: false,
};

Text.propTypes = {
  comment: PropTypes.bool,
  children: PropTypes.any.isRequired,
};
